var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fromFetch } from 'rxjs/fetch';
import { mergeMap } from 'rxjs/operators';
export function fetchTransport(input) {
    var headers = new Headers(__assign({ Accept: 'application/json;charset=utf-8' }, input.headers));
    var request = new Request(input.url, {
        method: input.method,
        headers: headers,
        credentials: input.credentials,
        mode: input.mode,
        body: input.body
    });
    return fromFetch(request).pipe(mergeMap(function (r) {
        return r
            .json()
            .catch(function (e) {
            console.error(e);
            return null;
        })
            .then(function (data) {
            var headers = {};
            r.headers.forEach(function (v, k) {
                headers[k] = v;
            });
            return {
                status: r.status,
                headers: headers,
                body: data
            };
        });
    }));
}
//# sourceMappingURL=fetchTransport.js.map